/**
 * 床に落ちている資材（§10.8）。
 *
 * **猫は資材を拾わない。** 落ちたまま、プレイヤーが拾うまでそこにある。
 * 消えないし腐らないので、拾い忘れても損はしない（§2.4 時間で急かさない）。
 *
 * 「拾いに行く作業」を作らないための線引きはここ：
 * 歩いて集めに行くのではなく、画面に見えている山を押すだけ。移動も順路も無い。
 */
import { Grid, isSolid } from './grid';
import { MaterialBundle, bundleTotal } from './materials';
import type { DropPile, GameState } from './state';

/** その列を下に辿って、物が落ちて止まる行を返す */
export function landingRow(grid: Grid, c: number, r: number): number {
  let row = r;
  while (row + 1 < grid.rows && !isSolid(grid, c, row + 1)) row++;
  return row;
}

/**
 * 落ちている資材を足す。
 * 同じマスのものはひと山にまとめる（タップ1回で拾えるように）。
 */
export function addDropTo(state: GameState, c: number, r: number, mats: MaterialBundle): void {
  if (bundleTotal(mats) <= 0) return;
  const row = landingRow(state.grid, c, r);
  const pile = state.drops.find((d) => d.c === c && d.r === row);
  if (pile) {
    for (const [id, n] of Object.entries(mats)) {
      const key = id as keyof MaterialBundle;
      pile.mats[key] = (pile.mats[key] ?? 0) + (n ?? 0);
    }
    return;
  }
  state.drops.push({ c, r: row, mats: { ...mats } });
}

export function dropAtIn(state: GameState, c: number, r: number): DropPile | null {
  return state.drops.find((d) => d.c === c && d.r === r) ?? null;
}
